import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoardingIndicator = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.0165 1.32831V2.96831M9.0165 5.18031V6.82031M9.0165 9.04031V10.6803M0.8125 9.68031C0.8125 9.94553 0.917857 10.1999 1.10539 10.3874C1.29293 10.575 1.54728 10.6803 1.8125 10.6803H12.0005C12.2657 10.6803 12.5201 10.575 12.7076 10.3874C12.8951 10.1999 13.0005 9.94553 13.0005 9.68031V7.84031C12.5967 7.73036 12.2403 7.49066 11.9863 7.15814C11.7322 6.82563 11.5945 6.41878 11.5945 6.00031C11.5945 5.58184 11.7322 5.17499 11.9863 4.84248C12.2403 4.50997 12.5967 4.27026 13.0005 4.16031V2.32031C13.0005 2.0551 12.8951 1.80074 12.7076 1.61321C12.5201 1.42567 12.2657 1.32031 12.0005 1.32031H1.8125C1.54728 1.32031 1.29293 1.42567 1.10539 1.61321C0.917857 1.80074 0.8125 2.0551 0.8125 2.32031V4.15631C1.2197 4.26366 1.57992 4.50278 1.83696 4.83635C2.09399 5.16992 2.23338 5.5792 2.23338 6.00031C2.23338 6.42143 2.09399 6.8307 1.83696 7.16428C1.57992 7.49785 1.2197 7.73696 0.8125 7.84431V9.68031Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgBoardingIndicator);
export { ForwardRef as ReactComponent };
